import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SelfAssessmentComponent } from '../self-assessment.component';

@Component({
  selector: 'app-sa-step-2',
  templateUrl: './sa-step-2.component.html',
  styleUrls: ['./sa-step-2.component.css']
})
export class SaStep2Component {
  
  constructor(
    public router: Router,
    public ss: SelfAssessmentComponent
  ) { }

  onChange() {
    const value = this.ss.selfAssessmentModel;
    this.ss.userService.saveSelfAssessment(value).subscribe({
      next: (value) => {
          console.log("saveSelfAssessment result: " + value);
      },
    });
  }
  
  _prevButton() { 
    this.router.navigateByUrl("/self-assessment/1");
 }
  _nextButton() { 
    this.router.navigateByUrl("/self-assessment/3");
 }
}
